import React from 'react';
interface ConfirmNoteProps {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
  label?: string;
}
export function ConfirmNote({
  children,
  tone = 'light',
  label = 'To confirm'
}: ConfirmNoteProps) {
  const isDark = tone === 'dark';
  return <p className={`flex items-start gap-3 border border-dashed px-5 py-4 text-sm leading-relaxed ${isDark ? 'border-white/30 text-white/60' : 'border-ink/25 text-ink/60'}`} data-id="element-33" data-mp="12a7pp2s98uw0">
      <span className={`mt-[2px] shrink-0 font-display text-[11px] font-semibold uppercase tracking-[0.18em] ${isDark ? 'text-accent-cyan' : 'text-accent-purple'}`} data-id="element-34" data-mp="t99m2llqapdy">
        {label}
      </span>
      <span data-id="element-35" data-mp="fburz3kj5tfn">{children}</span>
    </p>;
}